import { errorColor } from './status/error';
export const error = (mode)=>{
    const color = errorColor(mode);
    return {
        main: color.main,
        light: mode === 'light' ? color.lowContrast : color.highContrast,
        dark: mode === 'light' ? color.highContrast : color.lowContrast
    };
};

//# sourceMappingURL=error.js.map